export interface GetEk83ReportListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetEk83ReportListPagingAndFilterResponseData
}

export interface GetEk83ReportListPagingAndFilterResponseData {
    items: GetEk83ReportListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetEk83ReportListPagingAndFilterResponseItem {
    isGiris: number
    turu: string
    siraNo: string
    antrepoBeyannameNo: string
    tescilTarihi?: string
    kalemNo?: number
    rejimKodu?: number
    gtip?: string
    ticariTanimi?: string
    kapIcindeDokme?: string
    girisKapAdet?: number
    markaNo: any
    konteynerNo?: string
    girisBrutKilo?: number
    girisNetKilo?: number
    girisSatisaEsasBirim: any
    girisMiktar: any
    ozetBeyanNo?: string
    giristeToplamKap?: number
    antrepoyaGirisTarihi?: string
    tasitinAdi?: string
    plaka?: string
    teminatTuru?: string
    tutari?: number
    cikisBeyannameNo?: string
    cikisKalemNo?: number
    cikistaKapMiktar?: number
    cikisSatisaEsasBirim: any
    cikisSatisaEsasMiktar: any
    kalanKap?: number
    malCikisTarih?: string
    devirTarihi: any
    ilgiliGumrukBeyannamesi: any
    varsaAyniGumrukIdaresindekiAntrepolarArasiEsyaSevkindeKullanilanBelgenoVeTarihi: any
    varsaElleclemeyeIliskinBilgiler: any
    varsaGeciciCikisaIliskinBilgiler: any
    digerBilgiler: any
    aciklama: any
}

export const initialGetEk83ReportListPagingAndFilterResponseData: GetEk83ReportListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}